<template>
  <v-text-field
    outlined
    dense
    required
    v-bind="$attrs"
    color="primary"
    height="2.25rem"
    hide-details
  >
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseInput',
}
</script>

<style lang="scss">
/* temporary fix for labels */

body {
  &.unauthorized {
    .v-text-field__slot {
      .v-label {
        background-color: var(--white);
        transform: translateY(-16px) scale(0.75);
      }
    }
  }
}

.theme--light.v-text-field--outlined fieldset {
  border: 1px solid currentColor;
}
</style>
